import "./PlatformNotalia.module.css";
import Header from "@/reusable_sections/Header";
import HeroPlataforma from "./sections/HeroPlataforma";
import MDulos from "./sections/MDulos";
import CasosDeUso from "./sections/CasosDeUso";
import CtaFinal from "./sections/CtaFinal";
import Highlights from "./sections/Highlights";
import RoleAccessControl from "./sections/RoleAccessControl";
import Integrations from "./sections/Integrations";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function PlatformNotaliaPage() {
  return <div>
      <Header />
      <HeroPlataforma />
      <MDulos />
      <CasosDeUso />
      <Highlights />
      <CtaFinal />
      <RoleAccessControl />
      <Integrations />
      <FinalCallToAction />
      <Footer />
    </div>;
}